<template>    
    <div class="col backgroundForm">
        <div class="col col-md-6 offset-md-3">
            <div class="alert alert-success" role="alert">
                <h4 class="alert-heading" v-if="tipo=='rectifi'">Busqueda de Embarcaciones a Rectificar </h4>
                <h4 class="alert-heading" v-else>Busqueda de Embarcaciones y Actualización de Datos</h4>
                <p>Indique su {{ searchTypeR }}</p>
                <hr>
            </div>
            
            <div class="form-row" v-if="dRolUser">
                    <div class="form-group col offset-md-3 col-md-6">
                        <label for="captain_download" class="badge badge-info">CAPITANIA</label>
                        <transition name="fade" mode="out-in">
                            <select  name="captain_download" class="form-control" id="captain_download" v-model="port_select">
                                <option v-for="port in ports_rectification" :value="port" :key="port.id">{{ port.name_port }}</option>
                            </select>
                        </transition>
                    </div>
            </div>

            <form @submit.prevent="searchBoat">

                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    <label class="btn btn-success active" @click="mViewSearch">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="optionSearchR"  value="enrollment" checked> Nombre
                    </label>
                    <label class="btn btn-success" @click="mViewSearch">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="optionSearchR" value="name"> Matricula
                    </label>
                </div>

                <div class="form-group"> 
                    <label for="nombreEmbarcacion">{{ searchTypeR }}</label>
                    <input type="text" class="form-control" id="enrollment_boat_r" v-model="enrollment_boat_r" :placeholder="searchTypeR" autocomplete="off">
                    <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchTypeR }} </small>
                </div>
                <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" >Buscar</button>
            </form>
        </div>
        <br><br>
        <transition name="bounce">
        <div class="col-12 col-md-10 offset-md-1 table-responsive" v-if="statusSearchR">
            <table class="table table-striped">
                <thead class="thead-dark">
                    <tr>
                        <th scoped="col">#</th>
                        <th scoped="col">Nombre Embarcacion</th>
                        <th scoped="col">Tipo</th>
                        <th scoped="col">Matricula</th>
                        <th scoped="col">Caracteristicas</th>
                        <th scoped="col">Motor</th>
                        <th scoped="col" v-if="tipo=='rectifi'">Propietario</th>
                        <th scoped="col" v-if="tipo=='rectifi'">Estado<br>Verificacion</th>
                        <th scoped="col" >Hoja Tecnica</th>
                        <th scoped="col" v-if="tipo=='rectifi'">Matricula</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(boat, index) in boatsR" :key="boat.id">
                        <td>{{ index+1 }}</td>
                        <td>{{ boat.name_boat }}</td>
                        <td>{{ boat.detail_boat }}</td>
                        <td v-if="boat.enrollment">{{ boat.enrollment }}</td>
                        <td v-else>{{ boat.enrollment_old }}</td>
                        <td align="center"><button class="btn btn-outline-warning" data-toggle="modal" @click="mShowBoat(boat, boat.check)"><font-awesome-icon icon="folder-open" /></button></td>
                        <td align="center"><button class="btn btn-outline-info" @click="mShowEngine(boat, boat.check)"><font-awesome-icon icon="wrench" /></button></td>

                        <td align="center" v-if="tipo=='rectifi'"><button class="btn btn-outline-success" @click="mShowOwner(boat, boat.check)"><font-awesome-icon icon="user-tie" /></button></td>

                        <td align="center" v-if="tipo=='rectifi'">
                            <button v-if="boat.check === 'N'" class="btn btn-outline-danger" @click="mApprovVerification(boat.id_boat, index)"><font-awesome-icon icon="question-circle" /></button>
                            <button v-else class="btn btn-outline-success" disabled><font-awesome-icon icon="check" /></button>
                        </td>
                        <td align="center"><button class="btn btn-outline-primary" @click="mCallPrint(boat.id_boat)"><font-awesome-icon icon="tasks" /></button></td>
                        <td align="center" v-if="tipo=='rectifi'"><button class="btn btn-outline-danger" disabled @click="mCallPrint(boat.id_boat, 1)"><font-awesome-icon icon="print" /></button></td>
                    </tr>
                </tbody>
            </table>
        </div>
        </transition>

        <modal-engine :id-modal-rectification="idModalRec" :engine-rectification="activeEngineR" :typeGasolines="tGasolines" :name-ship="nameBoat" :is-editable="is_editable" :type-form="tipo"></modal-engine>

        <modal-owner :id-modal-owner-re="idModalOwner" :name-ship="nameBoat" :owner="ownerRec" :types-identification="typeIdentification" :countrys="nationality" :citys="citys" :is-editable="is_editable"></modal-owner>

        <modal-loading :id-modal="modalPro" :title="modalLoadTitle" :status-send="sendRequest" :is_editable="is_editable" ></modal-loading>

        <modal-boat :id-modal-boat-rec="idModalBoatR" :name-ship="nameBoat" :boat="boatActive" :material-heads="matHeads" :type-navigates="tNavigates" :typeShips="tShips" :type-propulsions="tPropulsions" :types-activity-ship="tActivityShip" :is-editable="is_editable" :type-form="tipo"></modal-boat>
    </div>
    
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';

import modalEngine from './ModalEngine';
import modalOwner from './ModalOwner';
import modalBoat from './ModalBoat';
import modalLoading from '../modal/modalLoading';

export default {
    name:'search-boat',
    props:{
        tipo:String
    },
    data(){
        return{
            statusSearchR:false,
            enrollment_boat_r:null,
            boatsR:[],
            activeEngineR:{},
            activeWonerR:[],
            optionSearchR:'name',
            idModalRec:'modalEngineRec',
            modalPro:'modalPRec',
            modalLoadTitle:'Solicitando',
            sendRequest:true,
            tGasolines:[],
            nameBoat:null,
            idModalOwner:'modalOwnerR',
            ownerRec:{},
            nationality:[],
            typeIdentification:[],
            citys:[],
            idModalBoatR:'idModalBoat',
            boatActive:{},
            matHeads:[],
            tNavigates:[],
            tShips:[],
            tPropulsions:[],
            tActivityShip:[],
            dRolUser:false,
            ports_rectification:[],
            port_select:null,
            is_editable:true
        }        
    },
    mounted(){
        this.mChargeInit();
    },
    computed:{
        searchTypeR(){
            switch(this.optionSearchR){
                case 'name':
                    return 'Nombre de la Nave';
                break;

                case 'enrollment':
                    return 'Matricula de la Nave';
                break;
            }
        },
        viewSearch(){
            switch(this.optionSearchR){
                case 'name':
                    this.vSearch=true;
                break;

                case 'enrollment':
                    this.vSearch=false;
                break;
            }
            return this.vSearch;
        },
        cSessionUser(){
            return this.$store.getters.getUserState;
        }
    },
    methods:{
        async mChargeInit(){
            const ports = await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);        
            this.ports_rectification=ports.data;
            this.dRolUser= this.cSessionUser.role !== 4 ? true:false;
        },
        searchBoat(){
            this.boatsR=[];
            this.statusSearchR=false;
            let auxPort;
            auxPort=this.dRolUser ? this.port_select.id : this.cSessionUser.portId;
            if(this.enrollment_boat_r !== null && auxPort!==null){
                
                // axios.get(`searchShipRectification/${this.optionSearchR}/${this.enrollment_boat_r}/${this.cSessionUser.portId}`)
                axios.get(`searchShipRectification/${this.optionSearchR}/${this.enrollment_boat_r}/${auxPort}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {
                    if(res.data.length > 0){
                        this.boatsR=res.data;
                        this.statusSearchR=true;
                    }else{
                        toastr.info('No hemos encontrado aproximaciones', 'Advertencia')
                    }
                }).catch(error => {
                    console.log(error);
                })
            }else{
                toastr.warning('Verifique que las opciones esten completas')
            }
        },
        mApprovVerification(idB, index){
            // console.log(idB);
            // console.log(index);
            let message = {
                title: 'Aprobar Revision',
                body: `Desea aprobar la revision de la Nave?`
            };

            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                .confirm(message)
                .then(function(dialog) {
                    resolve(true);          
                })
                .catch(function() {
                    resolve(false);
                });
            })

            npr.then(async (msg)=>{
                if(msg){
                    try {
                        let id={
                            id_ship:idB
                        }
                        this.modalLoadTitle='Aprobando';
                        this.mShowModalRec(this.modalPro);

                        let update_status= await axios.post(`approvVerification?api_token=${Vue.auth.getToken()}`, qs.stringify(id));
                        
                        if(update_status.data[0].status){
                            this.boatsR[index].check='S';
                            toastr.success(update_status.data[0].respuesta, "Exito");
                            setTimeout(()=>{
                                this.mCloseModalRec(this.modalPro);
                            }, 1000)   
                        }else{
                            toastr.error(update_status.data[0].respuesta, "Error");
                            setTimeout(()=>{
                                this.mCloseModalRec(this.modalPro);
                            }, 1000)   
                        }
                        
                    } catch (error) {
                        toastr.error('Ha ocurrido un error al tratar de actualizar a la nave', 'Error');
                        // cerramos el modal
                    }
                }else{
                    console.log('se ha rechazado la aprobacion de la nave')
                }                
            
            })
                
            
        },
        async mAssignEnroll(idb){
            try {
                let id={
                    id_ship:idb
                }
                this.mShowModalRec(this.modalPro);
                let ra= await axios.post(`assignEnrollD?api_token=${Vue.auth.getToken()}`, qs.stringify(id));
                // console.log(ra);
                if(ra.data.status){
                    toastr.success(ra.data.respuesta, "Exito");
                }else{
                    toastr.error(ra.data.respuesta, "Error");
                }
                setTimeout(()=>{
                    this.mCloseModalRec(this.modalPro);
                }, 1000)   
            } catch (error) {
                console.log(error)
                setTimeout(()=>{
                    this.mCloseModalRec(this.modalPro);
                }, 1000)   
            }            
        },
        mCallPrint(idb, tr=0){
            this.modalLoadTitle='Solicitando';
            this.mShowModalRec(this.modalPro);
            let u;
            if(tr===0){
                // u=`pdfReportBoat/${idb}`;
                u=`pdfReportBoat/${idb}?api_token=${Vue.auth.getToken()}`;
            }else{
                // u=`pdfEnrollmentShip/${idb}`;
                u=`pdfEnrollmentShip/${idb}?api_token=${Vue.auth.getToken()}`;
            }
            axios.get(u, 
            // axios.get(`pdfReportBoat/${idb}`, 
                {
                    responseType:'blob'
                })
                .then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Reporte.pdf');
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(()=>{
                        this.mCloseModalRec(this.modalPro);
                    }, 1000)
                })
                .catch(err=>{
                    console.error(err)
                    toastr.error('Ocurrio un error contacte al administrador', 'Error');
                    this.mCloseModalRec(this.modalPro);
                })
        },
        mShowBoat(b, ch){
            // aqui definir si es rectificacion 
            if(this.tipo=='rectifi'){
                this.is_editable = ch ==='S' ? false:true;
            }
            // console.log(b);
            this.mShowModalRec(this.modalPro);
            this.nameBoat=`${b.name_boat} ( ${b.enrollment !== null ? b.enrollment:b.enrollment_old} )`;

            this.mGetBoat(b.id_boat);
        },
        async mGetBoat(b){      
            console.log('llamando al servidor');
            try {         
                console.log(b);       
                const ba = await axios.get(`getBoatDetail/${b}?api_token=${Vue.auth.getToken()}`);
                const mh = await axios.get(`globals/materialhead?api_token=${Vue.auth.getToken()}`);
                const tn = await axios.get(`globals/navigates?api_token=${Vue.auth.getToken()}`);
                const ts = await axios.get(`globals/ships?api_token=${Vue.auth.getToken()}`);
                const tp = await axios.get(`submenus/4?api_token=${Vue.auth.getToken()}`);
                const tas = await axios.get(`ships/servicionave?api_token=${Vue.auth.getToken()}`);
                console.log(ba);
                
                
                let auxb={
                    idmaster:ba.data[0].id_maestro,
                    iddetalle:ba.data[0].id_detalle,
                    name_boat:ba.data[0].nombre,
                    flag:'BOLIVIA',
                    material_head:ba.data[0].material_construccion,
                    type_navigate:ba.data[0].destino_navegacion,
                    type_boat:ba.data[0].tipo_embarcacion,
                    propulsion:ba.data[0].propulsion,
                    trb:ba.data[0].trb,
                    trn:ba.data[0].trn,
                    eslora:ba.data[0].eslora,
                    manga:ba.data[0].manga,
                    puntal:ba.data[0].puntal,
                    calado_min:ba.data[0].calado_min,
                    calado_max:ba.data[0].calado_max,
                    year_construction:ba.data[0].anio_construccion,
                    site_contruction:ba.data[0].lugar_construccion,
                    cost_construction:ba.data[0].costo_construccion,
                    
                    activity_principal:ba.data[0].actividad_principal,
                    activity_secondary:ba.data[0].actividad_secundaria,
                    tipo_casco:ba.data[0].tipo_casco
                }
            

                this.boatActive = auxb;
                this.matHeads= mh.data;
                this.tNavigates = tn.data;
                this.tShips = ts.data;
                this.tPropulsions = tp.data;
                this.tActivityShip = tas.data;
                

                setTimeout(()=>{
                    
                        this.mCloseModalRec(this.modalPro);
                        this.mShowModalRec(this.idModalBoatR);
                }, 1000)
                // if(this.tipo!=='rectifi'){
                //     this.boatsR=[];
                // }
            } catch (error) {
                console.error('error al solicitar');
                setTimeout(()=>{                    
                        this.mCloseModalRec(this.modalPro);
                        this.mShowModalRec(this.idModalBoatR);
                }, 1000)
            }
            

        },
        mShowOwner(b, ch){
            this.is_editable=ch ==='S' ? false:true;
            this.mShowModalRec(this.modalPro);
            this.nameBoat=b.name_boat;
            this.mGetOwner(b.id_boat);
        },
        async mGetOwner(id){
            this.ownerRec={};
            try {
                // obtener el propietario el id vs si es que existe
                const resp=await axios.get(`getOwnerShip/${id}?api_token=${Vue.auth.getToken()}`);
                const i=await axios.get(`globals/ident?api_token=${Vue.auth.getToken()}`);
                const n=await axios.get(`globals/country?api_token=${Vue.auth.getToken()}`);
                const c=await axios.get(`globals/citys?api_token=${Vue.auth.getToken()}`);

                // const resp=await axios.get(`getOwnerShip/${id}`);
                // const i=await axios.get(`globals/ident`);
                // const n=await axios.get(`globals/country`);
                // const c=await axios.get(`globals/citys`);

                this.nationality=n.data;
                this.typeIdentification=i.data;
                this.citys=c.data;
                console.log(resp);
                if(resp.data.length > 0){
                    const o={
                        idvs:resp.data[0].id_vs,
                        idShip:id,
                        id:resp.data[0].id_property,
                        type_identification:resp.data[0].id_identification,
                        number_identification:resp.data[0].data_identification,
                        site_expedition:resp.data[0].expedido,
                        name:resp.data[0].name_property,
                        direction:resp.data[0].domicilio,
                        mobile:resp.data[0].celular,
                        phone:resp.data[0].telefono_fijo,
                        partner:resp.data[0].representante,
                        nationality:resp.data[0].nacionalidad
                    }
                    this.ownerRec=o;
                }else{
                    const o={
                        idvs:0,
                        idShip:id,
                        id:null,
                        type_identification:null,
                        number_identification:null,
                        site_expedition:null,
                        name:null,
                        direction:null,
                        mobile:null,
                        phone:null,
                        partner:null,
                        nationality:null
                    }
                    this.ownerRec=o;
                }
                setTimeout(()=>{
                
                    this.mCloseModalRec(this.modalPro);
                    this.mShowModalRec(this.idModalOwner);
                }, 1000)
                
            } catch (error) {
                console.error(error)
            }
        },
        mShowEngine(b, ch){
            this.is_editable= ch ==='S' ? false:true;
            this.mShowModalRec(this.modalPro);
            this.nameBoat=b.name_boat;
            this.mGetEngine(b.id_boat);
            
        },
        async mGetEngine(id){            
            try {
                // const response=await axios.get(`engineRectification/${id}`);                
                // const gasolines=await axios.get(`globals/gasoline`);
                const response=await axios.get(`engineRectification/${id}?api_token=${Vue.auth.getToken()}`);                
                const gasolines=await axios.get(`globals/gasoline?api_token=${Vue.auth.getToken()}`);

                this.tGasolines=gasolines.data;
                if(response.data.length > 0){
                    let aux={
                        id_motor:response.data[0].id_motor,
                        id_master:id,
                        trademark:response.data[0].marca,
                        model:response.data[0].modelo,
                        gasoline:response.data[0].combustible,
                        numero_motor:response.data[0].numero_motor,
                        rpm:response.data[0].hp_rpm,
                        serie:response.data[0].serie,
                        velocity_max:response.data[0].velocidad_max,
                        autonomia:response.data[0].autonomia
                    }
                    this.activeEngineR=aux;
                }else{
                    let aux={
                        id_motor:0,
                        id_master:id,
                        trademark:null,
                        model:null,
                        gasoline:null,
                        numero_motor:null,
                        rpm:null,
                        serie:null,
                        velocity_max:null,
                        autonomia:null
                    }
                    this.activeEngineR=aux;
                }
                setTimeout(()=>{                
                    this.mCloseModalRec(this.modalPro);
                    this.mShowModalRec(this.idModalRec);
                    this.boatsR=[];
                }, 1000)
            } catch (error) {
                console.error(error)
            }
            
        },
        mViewSearch(event){
            var radios=$("input[type=radio]").parents('label');
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            this.optionSearchR=radioV;
        },
        mShowModalRec(idM){
            $('#'+idM).modal('show');
        },
        mCloseModalRec(idM){
            $('#'+idM).modal('hide');
        }
    },
    components:{
        'modal-engine':modalEngine,
        'modal-loading':modalLoading,
        'modal-owner':modalOwner,
        'modal-boat':modalBoat
    }
}
</script>

<style>
.bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/rectification/SearchBoatRe.vue